var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9A5 5 0 114 9a5 5 0 0110 0zm-1.046 5.777a7 7 0 111.82-1.82L17 15.185a1.287 1.287 0 01-1.82 1.82l-2.226-2.227z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA5QzE0IDExLjc2MTQgMTEuNzYxNCAxNCA5IDE0QzYuMjM4NTggMTQgNCAxMS43NjE0IDQgOUM0IDYuMjM4NTggNi4yMzg1OCA0IDkgNEMxMS43NjE0IDQgMTQgNi4yMzg1OCAxNCA5Wk0xMi45NTM1IDE0Ljc3NzRDMTEuODI4NiAxNS41NDg3IDEwLjQ2NyAxNiA5IDE2QzUuMTM0MDEgMTYgMiAxMi44NjYgMiA5QzIgNS4xMzQwMSA1LjEzNDAxIDIgOSAyQzEyLjg2NiAyIDE2IDUuMTM0MDEgMTYgOUMxNiAxMC40NjkgMTUuNTQ3NSAxMS44MzIzIDE0Ljc3NDMgMTIuOTU4MUwxNyAxNS4xODM4QzE3LjUwMjYgMTUuNjg2NCAxNy41MDI2IDE2LjUwMTMgMTcgMTcuMDAzOUMxNi40OTc0IDE3LjUwNjUgMTUuNjgyNSAxNy41MDY1IDE1LjE4IDE3LjAwMzlMMTIuOTUzNSAxNC43Nzc0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgSearch20 as ReactComponent };